import { getPageUrl, isLandingPage } from '@/utils';
import { FormStoreProvider, useFormStore } from '../stores/FormStore';
import LandingPage from './LandingPage';
import Assets from './Assets';
import EmbeddedForm from './EmbeddedForm';
import SlideInForm from './SlideInForm';
import ModalForm from './ModalForm';

export const windowBoxShadow = '0px 5px 40px rgb(0,0,0,0.16)';

const formTypeComponentMap = {
	modal: ModalForm,
	slide: SlideInForm,
	embed: EmbeddedForm
};

export default function Form() {
	return (
		<FormStoreProvider>
			<div data-mop-page-url={getPageUrl()}>
				<Assets />
				<FormType />
				{isLandingPage() && <LandingPage />}
			</div>
		</FormStoreProvider>
	);
}

function FormType() {
	const { formType, hideLandingPageForm } = useFormStore();
	const FormComponent = formTypeComponentMap[formType] ?? null;
	if (hideLandingPageForm) {
		return null;
	}
	return <FormComponent />;
}
